import clsx from 'clsx';

export default function Content({
  children,
  className,
  containterStyles,
}: {
  children: React.ReactNode;
  className?: string;
  containterStyles?: any;
}) {
  return (
    <div className={clsx('flex w-full flex-col', className)} style={containterStyles}>
      {children}
    </div>
  );
}
